export default __webpack_public_path__ + "static/media/step2.d9800a5d.png";